import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { MainLayoutComponent } from './shared/layout/main-layout/main-layout.component';
import { PERMISSOES } from './core/constants/permissoes.constants';
import { permissaoGuard } from './core/guards/permissao.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'callback',
    loadComponent: () =>
      import('./pages/callback/callback.component').then((m) => m.CallbackComponent),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'aplicacoes',
        loadComponent: () =>
          import('./pages/aplicacoes/aplicacoes.component').then((m) => m.AplicacoesComponent),
      },
      {
        path: 'aplicacoes/:id',
        canActivate: [permissaoGuard([PERMISSOES.SGI.APLICACOES.LISTAR])],
        loadComponent: () =>
          import('./pages/aplicacoes/application-detail/application-detail.component').then((m) => m.ApplicationDetailComponent),
      },
      {
        path: 'usuarios',
        // canActivate: [permissaoGuard([PERMISSOES.SGI.PAGE_VIEW.ADMIN])],
        loadComponent: () =>
          import('./pages/usuarios/usuarios.component').then((m) => m.UsuariosComponent),
      },
      {
        path: 'acesso-negado',
        loadComponent: () =>
          import('./shared/components/design-system/error-page.component').then((m) => m.ErrorPageComponent),
        data: {
          type: '403',
          title: 'Acesso Negado',
          description: 'Você não tem as permissões necessárias para acessar este recurso.',
        },
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/components/design-system/error-page.component').then((m) => m.ErrorPageComponent),
    data: {
      type: '404',
      title: 'Página não encontrada',
      description: 'O caminho que você está tentando acessar não existe ou foi movido.',
    },
  },
];
